import React from "react";
import { Box, Card, Chip, Stack, Typography } from "@mui/material";
import SectionFrame from "../SectionFrame";
import { EditableText } from "../InlineEditable";

const CATEGORIES = ["Categoría 1", "Categoría 2", "Categoría 3", "Categoría 4"];

export default function CategoriesSection({ form, active, device, productsEnabled, onSelect, onCommit, onCommitMany, disabled }) {
  const isMobile = device === "mobile";
  const copy = form.catalog.categories || {};
  const primary = form.theme.primaryColor || "#F35A3A";
  const secondary = form.theme.secondaryColor || "#19242F";
  const enabled = productsEnabled && form.sections.showProducts !== false && form.sections.showCategories !== false;
  const toggle = (next) => onCommitMany
    ? onCommitMany({ "sections.showProducts": true, "sections.showCategories": next })
    : onCommit("sections.showCategories", next);

  return (
    <SectionFrame id="categories" label="Categorías" active={active} enabled={enabled} onSelect={onSelect} onToggle={productsEnabled ? toggle : undefined}>
      <Box sx={{ px: isMobile ? 2.2 : 5.5, py: isMobile ? 6 : 8, bgcolor: form.theme.backgroundColor || "#EEF0F5" }}>
        <Box sx={{ maxWidth: 1280, mx: "auto" }}>
          <EditableText value={copy.eyebrow} fallback="Categorías" disabled={disabled} onSave={(value) => onCommit("catalog.categories.eyebrow", value)} sx={{ color: primary, textTransform: "uppercase", letterSpacing: 1.2, fontWeight: 900, fontSize: 13 }} />
          <Box sx={{ mt: 0.5 }}><EditableText value={copy.title} fallback="Explorá por categorías" disabled={disabled} onSave={(value) => onCommit("catalog.categories.title", value)} sx={{ color: secondary, fontWeight: 950, fontSize: isMobile ? 34 : 44, letterSpacing: "-.035em" }} /></Box>
          <Box sx={{ mt: 1, maxWidth: 740 }}><EditableText value={copy.subtitle} fallback="Encontrá más rápido el tipo de producto que estás buscando." disabled={disabled} multiline onSave={(value) => onCommit("catalog.categories.subtitle", value)} sx={{ color: form.theme.mutedTextColor || "#5B5D73", lineHeight: 1.7 }} /></Box>
          <Box sx={{ mt: 3.5, display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(4,minmax(0,1fr))", gap: 1.5 }}>
            {CATEGORIES.map((category, index) => (
              <Card key={category} elevation={0} sx={{ p: isMobile ? 2 : 2.5, minHeight: isMobile ? 122 : 160, borderRadius: 4, border: "1px solid rgba(25,36,47,.09)", display: "flex", flexDirection: "column", justifyContent: "space-between", background: `linear-gradient(145deg, #fff, ${primary}10)` }}>
                <Box sx={{ width: 42, height: 42, borderRadius: 2.5, display: "grid", placeItems: "center", bgcolor: `${primary}1c`, color: primary, fontWeight: 950 }}>{index + 1}</Box>
                <Box sx={{ mt: 2 }}>
                  <Typography sx={{ color: secondary, fontWeight: 950 }}>{category}</Typography>
                  <Stack direction="row" spacing={0.7} alignItems="center" sx={{ mt: 0.7 }}><Chip size="small" label={`${index + 2} ${index === 0 ? copy.productSingular || "producto" : copy.productPlural || "productos"}`} /></Stack>
                </Box>
              </Card>
            ))}
          </Box>
        </Box>
      </Box>
    </SectionFrame>
  );
}
